import {Component, ElementRef, ViewChild, OnInit, ApplicationRef} from '@angular/core';
import {IonicPage, NavController, NavParams, Platform, PopoverController, ViewController} from 'ionic-angular';
import {CorePage} from '../../shared/interfaces/corePage.interface';
import {AuthService} from '../../shared/services/auth.service';
import {OauthService} from '../../shared/services/oauth.service';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import * as moment from 'moment';
import {LoadingService} from '../../shared/services/loading.service';
import {Subject} from 'rxjs/Subject';
import {Search} from '../../shared/models/search/search.model';
import {SondageListComponent} from '../../core/sondage-list/sondage-list.component';
import {CeContextService, PlatformContextService} from '../../shared/services/context';
import {PushService} from '../../shared/services/push.service';
import { UserStorageService } from '../../shared';
import {BlogArticleService} from "../../shared/services/blogArticle.service";
import {WebSliderService} from "../../shared/services/webSlider.service";
import { UserService } from "../../shared/services/user.service";
import {AppProvider} from "../../core/app/app-provider.service";

// import { StaticHomeSalariePopOverPage } from '../static-home-salarie-popover/static-home-salarie-popover';

@IonicPage()
@Component({
  selector: 'page-user-board',
  templateUrl: 'user-board.html'
})
export class UserBoardPage implements CorePage, OnInit {
  @ViewChild('popoverContent', {read: ElementRef})
  content: ElementRef;
  @ViewChild('popoverText', {read: ElementRef})
  text: ElementRef;

  //@ViewChild('carousel', {read: ElementRef}) carousel: ElementRef
  public allowedMode = ['salarie'];
  public authService;
  private currentUser;
  private today: string = moment().locale('fr').format('dddd D MMMM YYYY');
  public searchQuery$ = new Subject<Search>();
  public isDemoThierry = false;
  public webContainers = [];
  public websliderBanniere;
  private pageTitle: string = "";
  private blogArticleIdNotif: number = null;
  private needLoadElements: boolean = false;

  @ViewChild('sondageList') sondageList: SondageListComponent;
  public sondageSearchQuery$ = new Subject<Search>();

  constructor(
    private popoverCtrl: PopoverController,
    private viewCtrl: ViewController,
    public navCtrl: NavController,
    public lsService: LocalStorageService,
    public oauthService: OauthService,
    private loadingService: LoadingService,
    private platformContextService: PlatformContextService,
    private pushService: PushService,
    private storage: UserStorageService,
    private ceContext: CeContextService,
    private platform: Platform,
    private blogArticleService: BlogArticleService,
    private webSliderService: WebSliderService,
    private userService: UserService,
    private appRef: ApplicationRef,
    public navParams: NavParams,
    protected appProvider: AppProvider,
  ) {
    this.authService = new AuthService(
      this.allowedMode,
      this.navCtrl,
      this.oauthService,
      this.storage
    );

    this.pageTitle = this.navParams.get('pageTitle') ? this.navParams.get('pageTitle') : 'Accueil'
    this.currentUser = this.lsService.getUser();

    // On active le push que si on a accès au device
    if ((<any>window).cordova && this.platformContextService.isSalarie()) {
      this.pushService.init();

      // Souscrire au push pour ouvrir l'article lorsqu'on clique dessus
      this.pushService.notificationReceived.subscribe((blogArticleId: number) => {
        if (blogArticleId) {
          this.blogArticleIdNotif = blogArticleId
        }
      });
    }

    // Todo : Temporaire a remplacer par une gestion propre
    // Gestion du bandeau version "Desktop"
    if (this.ceContext.get().id == 300 && !(this.platform.is('android') || this.platform.is('ios'))) {
      this.isDemoThierry = true;
    }
  }

  ionViewWillEnter() {
    this.viewCtrl.showBackButton(false); // disable back button
    if (this.needLoadElements) {
      this.loadHomeElements();
      this.needLoadElements = false;
    }
  }

  ionViewCanEnter() {
    return this.authService.ionViewCanEnter();
  }

  ngOnInit(): void {

    // Sauvegarde des stats de connexion
    this.userService.saveStatUtilisateur().subscribe(resp => {}, error => console.log(error));

    // Attente de 2 sec pour vérifier si une valeur de blog a été passée en notif
    setTimeout(() => {
      // Un identifiant d'article est présent
      if (this.blogArticleIdNotif) {

        // Redirection vers le détail (sans passer par la liste)
        this.navCtrl.push('BlogArticleDetailPage', {blogArticle: this.blogArticleIdNotif});

        // Retirer la dernière valeur de blog recu pour éviter de continuellement afficher l'article
        this.pushService.notificationReceived.next(null);
        this.blogArticleIdNotif = null;

        // Au retour sur la page d'accueil, il faudra charger la liste des articles
        this.needLoadElements = true;
      }
      else {
        this.loadHomeElements();
      }
    }, 1000);

  }

  loadHomeElements(): void {

    this.sondageList.voted.subscribe(() => this.getSondageHomeList());
    this.searchQuery$.next({home: 1, offset: 0, limit: 15, orderBy: 'date', order: 'desc'} as Search);
    this.getSondageHomeList();

    // Chargement du slider et des container (uniquement Web)
    if (this.appProvider.web) {
      this.getWebSliders();
      this.getWebContainer();
    }
  }

  getWebSliders() {
    this.webSliderService.getWebSliders().subscribe(res => {
      this.websliderBanniere = res.find(ws => ws.type === 'home')
    });
  }

  private getSondageHomeList(): void {
    // this.loadingService.start();
    this.sondageSearchQuery$.next(new Search({ home: 1 }));
  }

  ionViewDidEnter() {
    this.loadingService.end();
  }

  getWebContainer(): void {
    this.blogArticleService.getWebContainer().subscribe(res => {
      this.webContainers = res;
    });
  }

  presentPopover(ev: UIEvent) {
  }

  getTitlePage() {
    if (this.isDemoThierry) {
      return "";
    }
    else {
      return this.pageTitle;
    }
  }

  onClick(id) {
    this.navCtrl.push('BlogArticleDetailPage', { blogArticle: id });
  }

  next(ref, container, width?: number) {
    if (width && ref.scrollLeft >= width * (container.blogArticle.length - 1)) {
      ref.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    } else if ((ref.scrollWidth - ref.scrollLeft) <= (  ref.scrollWidth / container.blogArticle.length)) {
      ref.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    } else {
      ref.scrollTo({
        left: ref.scrollLeft + (width ? width : ref.clientWidth),
        behavior: 'smooth'
      });
    }
    setTimeout(() => {
      this.appRef.tick();
    }, 500);
  }

  previous(ref, container, width?: number) {
    if ( ref.scrollLeft === 0) {
      ref.scrollTo({
        left: ref.scrollWidth - (width ? width : ref.clientWidth),
        behavior: 'smooth'
      });
    } else {
      ref.scrollTo({
        left: ref.scrollLeft - (width ? width : ref.clientWidth),
        behavior: 'smooth'
      });
    }
    setTimeout(() => {
      this.appRef.tick();
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-board/user-board.ts